import React, { useState, useEffect } from 'react'
import { ItemDetailsType, LeanFactory } from '../../types/ItemDetailsType'
import { Button, Grid } from '@enterprise-ui/canvas-ui-react'
import { Autocomplete } from '@enterprise-ui/canvas-ui-react-autocomplete'
import { AutoCompleteOptionType } from '../../types/AutoCompleteOptionType'
import { Location } from '../../types/BusinessPartnerType'
import { convertToFactoryOptions } from '../../utils/FactoryLocationsUtil'
import { lookupVendorIdDept } from '../../services/LookupService'
import { DatePicker } from '@enterprise-ui/canvas-ui-react-datepicker'
import { getDateFormatted } from '../../utils/DateUtil'

interface ReplaceFactoryFormProps {
  factoryToRemove: LeanFactory
  onReplaceFactory: (
    factoryToRemove: LeanFactory,
    factoryToAdd: LeanFactory,
  ) => void
  onCancel: () => void
  locations: Location[]
  showForm: boolean
  selectedVendor: AutoCompleteOptionType
  itemDetails: ItemDetailsType
}

export const ReplaceFactoryForm: React.FC<ReplaceFactoryFormProps> = ({
  factoryToRemove,
  onReplaceFactory,
  onCancel,
  locations,
  showForm,
  selectedVendor,
  itemDetails,
}) => {
  const [newFactoryLocationOption, setNewFactoryLocationOption] =
    useState<AutoCompleteOptionType>()

  const [isFormValid, setIsFormValid] = useState<boolean>(false)
  const [newVOP, setNewVOP] = useState<AutoCompleteOptionType>()

  const [factoryToAddEndDate, setFactoryToAddEndDate] = useState<Date>(
    factoryToRemove.effective_end_date,
  )

  useEffect(() => {
    const isValidNewFactoryInput = newFactoryLocationOption ? true : false
    setIsFormValid(isValidNewFactoryInput)
  }, [newFactoryLocationOption, newVOP, setIsFormValid])

  const replaceFactory = () => {
    if (newFactoryLocationOption && newVOP) {
      onReplaceFactory(factoryToRemove, {
        factory_id: newFactoryLocationOption ? newFactoryLocationOption.id : '',
        factory_name: newFactoryLocationOption
          ? newFactoryLocationOption.label
          : '',
        vendor_order_spec_id: newVOP.id,
        effective_start_date: factoryToRemove.effective_start_date,
        effective_end_date: factoryToAddEndDate,
        factory_active: true,
      })
    }
  }

  return (
    <>
      {showForm && (
        <Grid.Container
          direction="column"
          className="hc-bg-grey07 hc-ma-dense hc-pa-dense"
        >
          <Grid.Item>
            <Autocomplete
              id="factory"
              label="Select Replacement Factory"
              options={convertToFactoryOptions(locations)}
              required
              value={newFactoryLocationOption}
              errorText="Please select a factory"
              onUpdate={(id, value) => {
                setNewFactoryLocationOption(value)
              }}
            />
          </Grid.Item>
          <Grid.Item xs={7}>
            <Autocomplete
              label="VOP"
              id="vop"
              required
              filter={Autocomplete.filters.none}
              onUpdate={(id, value) => {
                setNewVOP(value)
              }}
              value={newVOP}
              options={async (value: any) => {
                return await lookupVendorIdDept(
                  selectedVendor.id + '-' + itemDetails.department_id,
                )
              }}
            />
          </Grid.Item>
          <Grid.Item xs={4}>
            <DatePicker
              id="effectiveEndDate"
              label="Effective End Date"
              disableDates={{
                before: getDateFormatted(factoryToRemove.effective_start_date),
              }}
              onUpdate={(_, value: any) => {
                value &&
                  setFactoryToAddEndDate(new Date(value + ' 00:00:00 GMT'))
              }}
              value={getDateFormatted(factoryToAddEndDate)}
              location="bottom-right"
            />
          </Grid.Item>
          <Grid.Item className="hc-mt-min">
            <Button
              type="primary"
              size="dense"
              disabled={!isFormValid}
              onClick={replaceFactory}
              className="hc-mr-normal"
            >
              Replace
            </Button>
            <Button size="dense" onClick={onCancel}>
              Cancel
            </Button>
          </Grid.Item>
        </Grid.Container>
      )}
    </>
  )
}
